import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { FRONTEND_URL } from "../config/axios";
import Applymodels from "../pages/Applymodels";
import { useNavigate } from "react-router-dom";
import { SearchBig } from "../components/AllSvg";
import { Notification } from "../components/AllSvg";
import { routingData } from "../routes/routing";
import { Modal } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

const Dashboardnavbar = ({ name, url, showurl }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const data = [
    // ... your existing data array
  ];

  const fetchData = async () => {
    const allNotifications = data;
    setNotifications(allNotifications.filter((n) => n.is_read === "Unread"));
    setUnreadCount(
      allNotifications.filter((n) => n.is_read === "Unread").length,
    );
    handleShowNotifications();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleShowNotifications = () => {
    notifications.forEach((notification) => {
      if (notification.is_read === "Unread") {
        toast(notification.message, {
          onClose: () => markAsRead(notification.emp_code),
        });
      }
    });
  };

  const markAsRead = (id) => {
    console.log("Marking as read for ID:", id);
    const updatedNotifications = notifications.map((notification) =>
      notification.id === id
        ? { ...notification, is_read: "Read" }
        : notification,
    );
    setNotifications(
      updatedNotifications.filter((n) => n.is_read === "Unread"),
    );
    setUnreadCount(
      updatedNotifications.filter((n) => n.is_read === "Unread").length,
    );
  };

  const empname = sessionStorage.getItem("name");
  const empCode = sessionStorage.getItem("sitemanagement_emp_code");
  const role = sessionStorage.getItem("sitemanagement_role");
  const EMAIL = sessionStorage.getItem("email");

  const clearAllNotifications = () => {
    const updatedNotifications = notifications.map((notification) => ({
      ...notification,
      is_read: "Read",
    }));
    setNotifications(
      updatedNotifications.filter((n) => n.is_read === "Unread"),
    );
    setUnreadCount(0);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();

  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [availableRoutes, setAvailableRoutes] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Get user info from sessionStorage
  const userName =
    sessionStorage.getItem("userName") ||
    sessionStorage.getItem("username") ||
    "User";
  const userRole =
    sessionStorage.getItem("role") ||
    sessionStorage.getItem("sitemanagement_role") ||
    "Role";
  const userEmail = sessionStorage.getItem("userEmail") || "";

  // Get first letter for avatar

  const flattenRoutes = (routes) => {
    let flatRoutes = [];

    const flatten = (routeList, parentPath = "") => {
      routeList.forEach((route) => {
        const fullPath = parentPath
          ? `${parentPath}/${route.path}`
          : route.path;
        if (!fullPath.includes("/:")) {
          const cleanedPath = fullPath.replace(/^admin\//, "");
          flatRoutes.push({ ...route, path: cleanedPath });
        }
        if (route.routes && Array.isArray(route.routes)) {
          flatten(route.routes, fullPath);
        }
      });
    };

    flatten(routes);
    return flatRoutes;
  };

  useEffect(() => {
    const userRole = sessionStorage.getItem("role") || "";
    const roleData = routingData.find((route) => route.role === userRole);

    if (roleData) {
      if (roleData.nestedRoutes && Array.isArray(roleData.nestedRoutes)) {
        const flattenedRoutes = flattenRoutes(roleData.nestedRoutes);
        setAvailableRoutes(flattenedRoutes);
      } else {
        setAvailableRoutes([]);
      }
    } else {
      setAvailableRoutes([]);
    }
  }, []);

  const handleSearchChange = (e) => {
    const input = e.target.value.trim();
    setSearchInput(input);

    if (input) {
      const filtered = availableRoutes.filter((route) =>
        (route.label || route.path).toLowerCase().includes(input.toLowerCase()),
      );
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");

  const handleSuggestionClick = (path) => {
    setSearchInput("");
    setSuggestions([]);
    setShowSuggestions(false);
    const staticPath = path.split("/:")[0];
    navigate(`/${urlParts[3]}/${staticPath}`);
  };

  const handleClickOutside = (e) => {
    if (!e.target.closest(".navbar-search")) {
      setShowSuggestions(false);
    }
    // Close profile menu when clicking outside
    if (!e.target.closest(".profile-dropdown")) {
      setShowProfileMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleShowMessenger = () => {
    navigate("/certificaionadminaccess/messenger");
  };

  // Handle logout
  const handleLogout = () => {
    toast.info("Logging Out...");
    sessionStorage.clear();
    setTimeout(() => {
      window.location = FRONTEND_URL;
    }, 500);
  };

  // Toggle profile menu
  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  console.log(showurl, "bd show");

  const getFirstLetter = () => {
    if (empname) {
      return empname.charAt(0).toUpperCase();
    } else {
      return "U";
    }
  };

  return (
    <div className="navbar-section-main" style={{ background: "transparent" }}>
      <div className="navbar-heading font-weight700" style={{ color: "black" }}>{name}</div>

    </div>
  );
};

export default Dashboardnavbar;
